<template>
    <FullFillBox
        :pageID="1032"
        @permissionData="(data) => {
            this.permissionDetails = data
        }"
    >
        <h4>{{ $t('inventory_delivery_list') }}</h4>
        <hr>
        <div ref="tabulatorTableUse"></div>
    </FullFillBox>
</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import {TabulatorFull as Tabulator} from "tabulator-tables";

export default {
    name: "InventoryDeliveryListView",
    components: {
        FullFillBox,
    },
    data(){
        return{
            permissionDetails: {},
        }
    },
    methods: {
        async getBackendData(){
            await this.$mainApi.get('api/inventory/stock-out-temp-multi?mode=list')
                .then(response => {
                    if(response.data.status === 80){
                        this.tabulator.setData(response.data.details)
                    }
                })
        }
    },
    mounted(){
        document.title = this.$t('title') + ' | ' + this.$t('inventory_delivery_list')
        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {formatter: 'rownum', maxWidth: 20, responsive: 0},
                {title: "stockOutDate", field: 'stockOutDate', visible: false},
                {title: "driverFK_id", field: 'driverFK_id', visible: false},

                {title: this.$t('inventory_stock_out_date'), field: 'viewStockOutDate', resizable: false, sorter: 'string',
                    responsive: 0,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'desc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {title: this.$t('inventory_stock_out_driver'), field: 'driver', resizable: false, sorter: 'string',
                    responsive: 0,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {title: this.$t('inventory_dn_no'), field: 'dn_no', resizable: false, sorter: 'number',
                    responsive: 0, width: 100,
                    headerFilter: "input", hozAlign: "center", vertAlign: "middle",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    formatter: () => {
                        return "<i class='bi bi-printer'></i>"
                    },
                    title: this.$t('inventory_dn_dn'),
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerSort: false, width: 100, responsive: 0,
                    cellClick: async (e, row, formatterParams) => {
                        this.$swal.showLoading()
                        await this.$mainApi.get(`api/inventory/stock-out-temp-multi?mode=dn&stock=${row.getData().stockOutDate}&driver=${row.getData().driverFK_id}`)
                            .then(response => {
                                if (response.data.status === 80) {
                                    window.open(this.$store.state.serverIp + response.data.details)
                                    this.$swal.close()
                                }else{
                                    this.$swal.fire({
                                        text: response.data.errors,
                                        icon: 'warning'
                                    })
                                }
                            })
                    }
                },
                {
                    formatter: () => {
                        return "<i class='bi bi-printer-fill'></i>"
                    },
                    title: this.$t('inventory_dn_pack'),
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerSort: false, width: 100, responsive: 0,
                    cellClick: async (e, row, formatterParams) => {
                        this.$swal.showLoading()
                        await this.$mainApi.get(`api/inventory/stock-out-temp-multi?mode=pack&stock=${row.getData().stockOutDate}&driver=${row.getData().driverFK_id}`)
                            .then(response => {
                                if (response.data.status === 80) {
                                    window.open(this.$store.state.serverIp + response.data.details)
                                    this.$swal.close()
                                }else{
                                    this.$swal.fire({
                                        text: response.data.errors,
                                        icon: 'warning'
                                    })
                                }
                            })
                    }
                },
            ],
            reactiveData: true, //enable data reactivity
            maxHeight: '90vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
        })
        this.getBackendData()
    }
}
</script>

<style scoped>

</style>
